export const PATH = '/payment-complements';
